module.exports = __webpack_public_path__ + "static/ACABADODETECHO-7e346242111dd8b1f566408ff30bab63.webp";